import { DemoIds, IDemo } from 'types'

import { getSharedAsset } from '../utils'

const video = getSharedAsset('aerial-applications.mp4', 'sessions', 'videos')
const poster = getSharedAsset('aerial-applications.png', 'sessions', 'posters')
const monolith = getSharedAsset('aerial-applications.png', 'sessions', 'monoliths')
const nextDemoThumbnail = getSharedAsset('5g-mec-and-smart-venues.png', 'demos', 'thumbnails')

export const aerialApplications: IDemo = {
  id: DemoIds.aerialApplications,
  video,
  monolith,
  poster,
  end: {
    header: 'Geospatial data and analysis using drone services.',
    body:
      'When paired with Verizon 5G, Aerial Applications’ Mapware has the potential to digitize geospatial intelligence in high fidelity for operational planning.',
    nextDemoText: '5G MEC and smart venues.',
    nextDemoId: DemoIds.mecAndSmartVenues,
    nextDemoThumbnail,
    previousDemoId: DemoIds.shotTracker
  }
}
